import styled from "@emotion/styled"
import type { PIconProps, TextWeight } from "@porsche-design-system/components-react"
import { PText } from "@porsche-design-system/components-react"
import { spacingStaticXs } from "@porsche-design-system/components-react/emotion"
import type { MessageDescriptor } from "react-intl"
import { FormattedMessage } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"
import { TagIcon } from "../tagIcon/TagIcon"
import { Tooltip } from "../tooltip/Tooltip"

type StatusEnum = "ACTIVE" | "INACTIVE" | "INVALID"

const statusEnumToIconPropsMap: Record<StatusEnum, PIconProps> = {
	ACTIVE: { name: "shopping-cart" },
	INACTIVE: { name: "shopping-cart-off" },
	INVALID: { name: "error" },
}

const statusEnumToMessageMap: Record<StatusEnum, MessageDescriptor> = {
	ACTIVE: commonMessages.yes,
	INACTIVE: commonMessages.no,
	INVALID: commonMessages.invalid,
}

interface View {
	hint: string
	status: StatusEnum
}

interface OnlineOrderingIconProps {
	className?: string
	hideLabel?: boolean
	view: View
	weight?: TextWeight
}

export const OnlineOrderingIcon = ({ hideLabel, view, weight, ...rest }: OnlineOrderingIconProps) => {
	const { hint, status } = view
	const icon = (
		<StyledTagIcon
			color={status === "INVALID" ? "error" : undefined}
			iconName={statusEnumToIconPropsMap[status].name}
			{...rest}
		/>
	)

	return (
		<Tooltip appendToBody content={hint}>
			{hideLabel ? (
				icon
			) : (
				<Wrapper>
					{icon}
					<PText weight={weight}>
						<FormattedMessage {...statusEnumToMessageMap[status]} />
					</PText>
				</Wrapper>
			)}
		</Tooltip>
	)
}

const Wrapper = styled.div`
	display: flex;
	gap: ${spacingStaticXs};
	justify-self: start; /* to center tooltip on actual content, not the available width */
`

const StyledTagIcon = styled(TagIcon)`
	margin: -3px 0;
`
